module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6V2EP"))).then(() => parcelRequire('d0iPb'));